/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import { ConfirmationDialog } from '@mummssoftware/common-ui';
import { EditRow } from './EditRow';
import { CPFContext } from '../Context/CPFContext';

import defaults from '../../translations/en.json';

export const EditRowDialog = () => {
  const { editRowOpen } = useContext(CPFContext);

  return editRowOpen ? (
    <>
      <ConfirmationDialog
        title={defaults.editFreq}
        disableBackdropClick
        fullWidth
        maxWidth="xs"
        open={editRowOpen}
        noScroll={window.innerHeight > 400}
        handleClick={() => null}
        noIcon
      >
        <EditRow />
      </ConfirmationDialog>
    </>
  ) : (
    <></>
  );
};
